"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.post = void 0;
const polly = require("polly-js");
const uuid_1 = require("uuid");
// eslint-disable-next-line no-undef
const defaultRequestOptions = { mode: 'cors' };
const call = (url, body, 
// eslint-disable-next-line no-undef
headers, 
// eslint-disable-next-line no-undef
requestOverrides) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const logger = (_a = window.mgm) === null || _a === void 0 ? void 0 : _a.logger;
    // eslint-disable-next-line no-undef
    const reqHeaders = new Headers({
        'Content-Type': 'application/json',
    });
    if (logger && logger.CORRELATION_ID_KEY) {
        reqHeaders.append(logger.CORRELATION_ID_KEY, logger.getCorrelationId());
        reqHeaders.append(logger.JOURNEY_ID_KEY, logger.getJourneyId());
    }
    else {
        reqHeaders.append('x-mgm-correlation-id', (0, uuid_1.v4)());
    }
    headers === null || headers === void 0 ? void 0 : headers.forEach((value, key) => {
        reqHeaders.set(key, value);
    });
    const requestOptions = Object.assign(Object.assign(Object.assign({}, defaultRequestOptions), { headers: reqHeaders, body: body ? JSON.stringify(body) : undefined }), requestOverrides);
    const result = yield polly()
        .handle((error) => error instanceof TypeError)
        .waitAndRetry([100, 200])
        .executeForPromise(() => globalThis.fetch(url, requestOptions));
    return result;
});
const post = (url, body, 
// eslint-disable-next-line no-undef
headers, 
// eslint-disable-next-line no-undef
requestOverrides) => call(url, body, headers, Object.assign({ method: 'POST' }, requestOverrides));
exports.post = post;
const get = (url, 
// eslint-disable-next-line no-undef
headers, 
// eslint-disable-next-line no-undef
requestOverrides) => call(url, undefined, headers, Object.assign({ method: 'GET' }, requestOverrides));
exports.get = get;
